import type { VoiceParameters } from '../models/voice-parameters.ts'
import type { VoiceFacets } from '../../data/dto/voice.dto.ts'

export const mapVoiceFacetsToVoiceFilters = (
  facet: VoiceFacets
): VoiceParameters => ({
  accents: facet.accent,
  languages: facet.language,
  tags: facet.tags,
})
